const apiUrl = '';
const douzeroDemoUrl = 'https://outer-perfectdou-demo-gzailab.nie.netease.com:10074';

export { apiUrl, douzeroDemoUrl };
